<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-default">
    </base-header>
    <b-container fluid class="mt--7">
      <b-row>
        <b-col>
          <b-card no-body>
            <b-card-header class="border-0">
              <div class="row">
                <div class="col-lg-6 col-md-6">
                  <h3 class="mb-0">Listado de notificaciones</h3>
                </div>
                <div class="col-lg-6 col-md-6 d-flex justify-content-end">
                  <select name="per_page" id="per_page" v-model="pagination.limit" class="form-control" @change="reloadPaginate(1)">
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="200">200</option>
                  </select>
                  <input type="text" class="form-control" placeholder="Filtrar por destino, titulo o mensaje" v-model="pagination.search" @keyup="manualSearch">
                </div>
              </div>
            </b-card-header>

            <b-card-body>
              <div class="table-responsive">
                <table class="table table-bordered table-striped table-sm">
                  <thead>
                  <tr>
                    <th class="text-uppercase  font-weight-bolder opacity-7">DESTINO</th>
                    <th class="text-uppercase  font-weight-bolder opacity-7">TITULO</th>
                    <th class="text-uppercase  font-weight-bolder opacity-7">MENSAJE</th>
                    <th class="text-uppercase  font-weight-bolder opacity-7">ICONO</th>
                    <th class="text-uppercase  font-weight-bolder opacity-7">DEFAULT</th>
                    <th class="text-uppercase  font-weight-bolder opacity-7">FECHA</th>
                    <th class="text-uppercase  font-weight-bolder opacity-7">OPCIONES</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item, key) in arrayNotifications" :key="key">
                    <td>
                      <span class="text-uppercase text-xs font-weight-bold mb-0">{{item.type}}</span>
                    </td>
                    <td>
                      <span class="text-uppercase text-xs font-weight-bold mb-0">{{item.title}}</span>
                    </td>
                    <td>
                      <div class="limited-width_30">
                        <span class="text-uppercase text-xs font-weight-bold mb-0">{{item.message}}</span>
                      </div>
                    </td>
                    <td>
                      <span class="text-xs font-weight-bold text-white badge rounded-pill" :class="item.icon=== 'error'? 'bg-danger': 'bg-' + item.icon">
                        {{item.icon}}
                      </span>
                    </td>
                    <td>
                      <b-checkbox v-model="item.default" :disabled="item.default" @change="makeDefaul(item)"></b-checkbox>
                    </td>
                    <td>
                      <span class="text-xs font-weight-bold mb-0">{{ item.created_at|date }}</span>
                    </td>
                    <td>
                      <button class="btn btn-outline-primary btn-sm mb-0" @click="deleteNotification(item._id)">borrar</button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </b-card-body>

            <b-card-footer class="py-4 d-flex justify-content-between">
              <p class="text-xs font-weight-bold mb-0">total registros: {{pagination.totalRows}}</p>
              <base-pagination @change="reloadPaginate" v-model="pagination.page" :per-page="Number(pagination.limit)" :total="pagination.totalRows"></base-pagination>
            </b-card-footer>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import {Table, TableColumn} from 'element-ui'
import {get, post} from "@/util/axiosRequest";

export default {
  name: 'page-visits-table',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data: () => ({
    pagination: {
      searchTimer: null,
      page: 1,
      pages: 0,
      limit: 20,
      search: '',
      totalRows: 0
    },
    arrayNotifications: [
      {
        bank: '',
        title: '',
        message: '',
        icon: '',
        status: '',
        created_at: ''
      },
    ],
  }),
  mounted() {
    this.getData()
  },
  methods: {
    reloadPaginate(page){
      this.pagination.page = page
      this.getData()
    },
    manualSearch(){
      clearTimeout(this.pagination.searchTimer);
      this.pagination.searchTimer = setTimeout(() => {
        this.reloadPaginate(1)
      }, 2000);
    },
    getData() {
      this.arrayNotifications = []
      get(`notifications/find-all?page=${this.pagination.page}&limit=${this.pagination.limit}&search=${this.pagination.search}`, null, true).then(({data}) => {
        this.arrayNotifications = data.docs
        this.pagination.totalRows = data.count
        this.pagination.page = data.page
        this.pagination.pages = data.pages
      })
    },
    remove(id) {
      post("notifications/remove", {_id: id}, true).then(() => {
        this.getData()
        this.showMessage("Notificacion desactivada correctamente")
      })
    },
    deleteNotification(id) {
      post("notifications/delete", {_id: id}, true).then(() => {
        this.getData()
        this.showMessage("Notificacion borrada correctamente")
      })
    },
    makeDefaul(row){
      post(`notifications/make-default`, {_id: row._id, type: row.type}, true)
      .then(() => this.getData())
    },
    showMessage(message, type = 'success') {
      this.$swal({
        html: message,
        icon: (type === "success") ? 'success' : 'error',
        showCloseButton: true,
        show: false,
        confirmButtonColor: '#191c4d',
        cancelButtonColor: '#191c4d',
      });
    },
  }
}
</script>
<style scoped>

</style>

